import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as o}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const e=t("remove",o`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.25 13.6699C2.89583 13.6699 2.59896 13.5501 2.35937 13.3105C2.11979 13.071 2 12.7741 2 12.4199C2 12.0658 2.11979 11.7689 2.35937 11.5293C2.59896 11.2897 2.89583 11.1699 3.25 11.1699H20.75C21.1042 11.1699 21.401 11.2897 21.6406 11.5293C21.8802 11.7689 22 12.0658 22 12.4199C22 12.7741 21.8802 13.071 21.6406 13.3105C21.401 13.5501 21.1042 13.6699 20.75 13.6699H3.25Z"
                fill="#FCFCFC" />
        </svg>
    `);export{e as Remove};
